import { css } from "@emotion/react";
import { useCanEditAbTestExplore } from "@src/hooks/ab-testing/can/use-can-edit-ab-test";

export const ABTestContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { canEdit } = useCanEditAbTestExplore();
  return (
    <div
      css={
        canEdit
          ? css`
              .ant-page-header-heading {
                display: none;
              }
              .ant-page-header-content {
                padding: 0;
              }
            `
          : css`
              .ant-page-header-heading {
                display: none;
              }
              .ant-page-header-content {
                padding: 0;
              }
              .ab-title-group {
                span {
                  background: rgba(0, 0, 0, 0.04) !important;
                  color: rgba(0, 0, 0, 0.25) !important;
                  cursor: not-allowed !important;
                  pointer-events: none !important;
                  &:hover {
                    border-color: #d9d9d9 !important;
                  }
                }
              }
              .ab-save-group {
                button {
                  background: rgba(0, 0, 0, 0.04) !important;
                  color: rgba(0, 0, 0, 0.25) !important;
                  cursor: not-allowed !important;
                  pointer-events: none !important;
                  &:hover {
                    border-color: #d9d9d9 !important;
                  }
                }
              }
            `
      }
    >
      {children}
    </div>
  );
};
